<!-- -->
<template>
  <div :class="{ frame: true, 'm-frame': isMobile }">
    <a
      href="https://e.baidu.com/case/?refer=800"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img :src="URL + 'banner_case.jpg'" alt="" class="banner" />
    </a>
    <div class="box">
      <div class="title-box">
        <div class="title">案例展示</div>
      </div>
      <div class="list-list" v-if="list.length != 0">
        <div class="list">
          <div
            class="item"
            v-for="item in list"
            :key="item.id"
            @click="navToDetail(item.id)"
          >
            <div class="good" v-show="item.goodExampleFlag == 1">优秀案例</div>
            <div class="post">
              <img :src="URL + item.newsImageUrl" alt="" />
            </div>
            <div class="bottom">
              <div class="title">{{ item.title }}</div>
              <div class="data" v-show="item.averageCrt">
                <img src="@/assets/icon_case_pointer.png" alt="" class="icon" />
                <div class="num">{{ item.averageCrt }}%</div>
              </div>
              <div class="data data2" v-show="item.exposureShow">
                <img src="@/assets/icon_case_push.png" alt="" class="icon" />
                <div class="num">{{ item.exposureShow }}W</div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.pageIndex"
          :page-size="queryParams.pageSize"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-empty description="暂无案例" v-else></el-empty>
    </div>
    <submit v-if="!isMobile" />
  </div>
</template>

<script>
import submit from "@/components/submit.vue";
import { URL } from "@/util/config";
import { Store } from "@/store/index.js";
import { mapState } from "pinia";

export default {
  components: { submit },
  data() {
    return {
      URL,
      bannerList: [
        {
          name: "百度搜索",
          bg: URL + "search_bg.jpg",
          desc: "百度系列产品每天超60亿次搜索请求\n超过1亿用户浏览百度信息流、800亿次定位服务请求\n覆盖用户生活全场景",
        },
        {
          name: "百度信息流",
          bg: URL + "info_bg.png",
          desc: "将您的推广信息自然融入在各类资讯、信息中，易传播，易操作",
        },
        {
          name: "百度爱采购",
          bg: URL + "aicaigou_bg.png",
          desc: "帮助用户一站直达全网商品信息，触达海量优质商家，通过安全便捷的交易能力全网采购",
        },
        {
          name: "百度品牌专区",
          bg: URL + "brand_bg.png",
          desc: "品牌专区，快速建立您的企业品牌公信力，首位霸屏，强展现",
        },
        {
          name: "百度开屏广告",
          bg: URL + "ad_bg.png",
          desc: "百度开屏矩阵，是以围绕百度APP搭建的百度系开屏产品矩阵",
        },
        {
          name: "网站建设",
          bg: URL + "web_bg.png",
          desc: "盘古广告建站是帮助中小企业快速搭建企业网站的自助建站产品",
        },
      ],
      queryParams: {
        pageIndex: 1,
        pageSize: 15,
      },
      list: [],
      total: 0,
      show: false,
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleCurrentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    async getList() {
      let res = await this.$api.getCaseList(this.queryParams);
      this.list = res.data.list;
      this.total = res.data.total;
    },
    navToDetail(id) {
      this.$router.push("/caseDetail/" + id);
      window.scrollTo({ top: 0 });
    },
  },
};
</script>

<style lang="scss" scoped>
$-width: 1200px;
#banner {
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 650px;
    object-fit: cover;
  }
  .in {
    width: 1200px;
    position: absolute;
    left: 50%;
    top: 130px;
    transform: translateX(-50%);

    .title {
      font-size: 56px;
      font-weight: bold;
    }
    .sub {
      margin-top: 50px;
      height: 100px;
      color: #2a2f39;
      font-size: 23px;
      line-height: 35px;
      white-space: pre-wrap;
    }
    .btns {
      margin-top: 90px;
      display: flex;

      .btn {
        width: 170px;
        height: 53px;
        font-size: 21px;
        line-height: 53px;
        text-align: center;
      }
      .primary {
        color: #fff;
        background-color: $theme;
      }
      .white {
        color: $theme;
        background-color: #fff;
        margin-left: 25px;
      }
    }
    .line {
      margin-top: 40px;
      background-color: $theme;
      width: 49px;
      height: 8px;
    }
  }
}
.banner {
  width: 100%;
}
.title-box {
  text-align: center;
  position: relative;
  z-index: 2;

  &::after {
    content: "";
    display: block;
    width: 70px;
    height: 4px;
    background-color: $theme;
    margin: 20px auto 0;
  }
  .title {
    font-size: 40px;
    color: $theme;
  }
}
.box {
  padding: 60px 0 40px;
  position: relative;

  .bg {
    width: 100%;
    height: 518px;
    object-fit: cover;
    position: absolute;
    top: 110px;
    z-index: 1;
  }
  .list {
    width: $-width;
    margin: 50px auto 0;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;

    .item {
      width: 360px;
      border-bottom: 5px solid $theme;
      border-radius: 6px;
      overflow: hidden;
      box-shadow: 8px 13px 30px rgba(0, 0, 0, 0.15);
      margin-bottom: 60px;
      transition: transform 0.5s;
      position: relative;
      cursor: pointer;
      margin-left: 60px;

      &:hover {
        transform: translateY(-10px);
      }
      &:nth-child(3n + 1) {
        margin-left: 0;
      }
      .good {
        width: 100px;
        height: 40px;
        color: #fff;
        font-size: 17px;
        text-align: center;
        line-height: 40px;
        border-bottom-right-radius: 15px;
        box-shadow: 2px 3px 6px rgba($color: #444444, $alpha: 0.81);
        background-color: $theme;
        position: absolute;
        left: 0;
        top: 0;
      }
      .post {
        width: 100%;
        height: 240px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
      .bottom {
        padding: 12px 23px;

        &::after {
          content: "";
          display: block;
          clear: both;
        }
        .title {
          font-size: 20px;
          margin-bottom: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .data {
          float: left;
          padding: 2px 10px;
          border-radius: 7px;
          border: 1px solid $theme;
          display: flex;
          align-items: center;

          .icon {
            width: 18px;
          }
          .num {
            margin-left: 5px;
            font-size: 25px;
            color: $theme;
          }
        }
        .data2 {
          float: right;
        }
      }
    }
  }
}

.m-frame {
  .banner {
    height: 165px;
    object-fit: cover;
  }
  .title-box {
    &::after {
      content: "";
      width: 50px;
      height: 2px;
      margin-top: 10px;
    }
    .title {
      font-size: 25px;
      font-weight: bold;
    }
  }
  .box {
    padding-top: 40px;

    .list {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      margin-top: 30px;

      .item {
        width: 100%;
        margin-bottom: 20px;
        margin-left: 0;

        .good {
          font-size: 14px;
          height: 30px;
          line-height: 30px;
        }
        .bottom {
          padding: 10px 15px;
          box-sizing: border-box;

          .title {
            font-size: 18px;
          }
          .data {
            .icon {
              width: 14px;
            }
            .num {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
